import { createContext } from "react";

export interface IValueContext {
  value?: any;
  setValue?: (value: any) => void;
}

export const ValueContext = createContext<IValueContext>({});
